import { clone } from "@dataspecer/core/core";
export async function structureModelAddJsonProperties(structure, reader) {
    const result = clone(structure);
    const classes = result.getClasses();
    for (const structureClass of classes) {
        const jsonStructureClass = structureClass;
        const resource = await reader.readResource(structureClass.psmIri);
        jsonStructureClass.jsonIdKeyAlias = resource.jsonIdKeyAlias;
        jsonStructureClass.jsonIdRequired = resource.jsonIdRequired;
        jsonStructureClass.jsonTypeKeyAlias = resource.jsonTypeKeyAlias;
        jsonStructureClass.jsonTypeRequired = resource.jsonTypeRequired;
    }
    return result;
}
//# sourceMappingURL=add-json-properties.js.map